import { Tab, Tabs, Theme, styled } from '@material-ui/core';

export const StyledTabs = styled(Tabs)<Theme>(({ theme }) => ({
  minHeight: 0,
  marginRight: theme.spacing(2),
  padding: theme.spacing(2),
  width: 'auto',
  display: 'flex',
  flexDirection: 'row',
}));

export const StyledTab = styled(Tab)<Theme>(({ theme }) => ({
  minHeight: 0,
  padding: theme.spacing(1),
  fontFamily: theme.config.secondaryFontFamily,
  fontSize: theme.typography.subtitle1.fontSize,
  border: `1px solid ${theme.config.appbarColors.borderColor}`,
  '&.Mui-selected': {
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.common.white,
  },
  '&:first-of-type': {
    borderTopLeftRadius: '4px',
    borderBottomLeftRadius: '4px',
  },
  '&:last-of-type': {
    borderTopRightRadius: '4px',
    borderBottomRightRadius: '4px',
  },
}));
